import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-username-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { checkUsername } from '../../api/profile.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function RegisterUsername() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      username: '',
    },
    validate: {
      username: (value) => (value.length < 2 ? FORM_ERRORS.USERNAME_LENGTH_VALIDATION : null),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    checkUsername(values.username)
      .then(() => {
        setIsLoading(false);
        localStorage.setItem('ffm_register_username', values.username.toLowerCase());
        navigate(LINKS.REGISTER_ACCOUNT_TYPE);
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.status === 409 || error.response.status === 400) {
          form.setErrors({
            username: error.response.data.fields?.find(
              (field: { fieldName: string; message: string }) => field.fieldName === 'username',
            )?.message,
          });
        }
      });
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} />;
}

export default RegisterUsername;
